import {isEqual} from 'lodash';
import {connect} from 'react-redux';
import {mkPersistedCoverImageSelection} from '../actionCreators/coverImagesUtil';
import CoverImages from '../lib/CoverImages';
import CustomiseCoverPageImagesModal from './CustomiseCoverPageImagesModal';

const mapStateToProps = (state) => {
	return {
		propertyId: state.propertyDetail.propertyId,
		selectedImage: CoverImages.selectedImage(state),
		reportType: state.reportType.value,
	};
};

const mapDispatchToProps = (dispatch) => ({
	onSave: ({src, type, zoom, x, y, reportType, propertyId}) => {
		mkPersistedCoverImageSelection({
			dispatch,
			imageUri: src,
			propertyId,
			reportType,
			type,
			zoom,
			x,
			y,
		});
	},
});

const mergeProps = (stateProps, dispatchProps) => ({
	...stateProps,
	...dispatchProps,
	onSave: ({src, type, zoom, x, y}) => {
		let persistedCoverImage = stateProps.selectedImage;
		let updatedCoverImage = {src, type, zoom, x, y};
		if (!isEqual(persistedCoverImage, updatedCoverImage)) {
			dispatchProps.onSave({src, type, zoom, x, y, reportType: stateProps.reportType, propertyId: stateProps.propertyId});
		}
	},
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(CustomiseCoverPageImagesModal);